import isEmpty from "lodash/isEmpty";
import { useEffect } from "react";
import { useSelector } from "react-redux";

import { Col, Container, Row } from "react-bootstrap";
import * as title from "../../constants/titles";
import IleggelseNumberTabsContainer from "./IleggelseNumberTabsContainer";
import "./Klage.css";
import KlageInfoContainer from "./KlageInfoContainer";
import KlageSearchFormContainer from "./klageSearchFormContainer";
import KlageTitleAndBeslutningsLinker from "./KlageTitleAndBeslutningsLinker";
import KlageVedtakContainer from "./VedtakerContainer";

function KlagePage() {
  const klageId = useSelector((state) =>
    state.klageDetail && state.klageDetail.id ? state.klageDetail.id : "",
  );
  const sak = useSelector((state) => state.sak);
  const KlageIleggelserFilterFormState = useSelector(
    (state) => state.forms.KlageIleggelseFilterFormState,
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    document.title = title.klage;
  }, []);

  const manglerInfo = () => {
    const klageInfo = sak && sak.kontakt;
    if (klageInfo === undefined) return false;
    return (
      isEmpty(klageInfo) ||
      isEmpty(klageInfo.postnummer) ||
      isEmpty(klageInfo.poststed)
    );
  };

  const showContent = () => {
    return klageId !== "" && KlageIleggelserFilterFormState.saksnummer !== "";
  };

  const isManglerInfo = manglerInfo();

  return (
    <section>
      <KlageSearchFormContainer />
      {klageId && (
        <Container fluid>
          <KlageTitleAndBeslutningsLinker
            sak={sak}
            klageId={klageId}
            manglerInfo={isManglerInfo}
          />
          {showContent() && (
            <div className="klageContainer">
              <Container className="KlageOgIleggelseTabber" fluid>
                <Row>
                  <Col xl={4}>
                    <KlageInfoContainer />
                  </Col>
                  <Col xl={8}>
                    <IleggelseNumberTabsContainer manglerInfo={isManglerInfo} />
                  </Col>
                </Row>
              </Container>
              <KlageVedtakContainer manglerInfo={isManglerInfo} />
              <div style={{ hight: 300 }} />
            </div>
          )}
        </Container>
      )}
    </section>
  );
}

export default KlagePage;
